
import { Component, Vue, Watch } from 'vue-property-decorator'

import ItemModal from '../modules/ItemModal.vue'
import CheckoutModal from '../modules/order/CheckoutModal.vue'
import Item from '../modules/Item.vue'
import CategoryHeader from '../modules/headers/CategoryHeader.vue'
import UserDropdown from '../modules/user/UserDropdown.vue'
import Cart from '../modules/Cart.vue'
import SearchHeader from '../modules/headers/SearchHeader.vue'
import UserModule from '../modules/headers/UserModule.vue'
import LoginModal from '../modules/user/LoginModal.vue'
import RegisterModal from '../modules/user/RegisterModal.vue'
import Categories from '../components/Categories.vue'
import PriceFilter from '../components/PriceFilter.vue'
import FooterLayout from '../pages/homepage/Footer.vue'
import { envConfiguration } from '../plugins/globalStaticDatas'

import BuyNowModal from '@/modules/order/BuyNowModal.vue'
import { isMobile } from '@/plugins/globals'
@Component({
  components: {
    RegisterModal,
    LoginModal,
    UserModule,
    SearchHeader,
    Cart,
    UserDropdown,
    CategoryHeader,
    Item,
    CheckoutModal,
    ItemModal,
    Categories,
    PriceFilter,
    FooterLayout,
    BuyNowModal,
  },
})
export default class PageLeyout extends Vue {
  isMobile = false
  envConfigurations: any = envConfiguration

  mounted() {
    this.isMobile = isMobile() && !window.location.pathname.includes('daily-menu')
  }
}
